import React from "react";
import { StyledDashBoardContainer } from "./styles";
import { translate } from "../../utils/translations/translate";
import { MonthEvents } from "../MonthPicker/MonthEvents";
import { ProgressBar } from "../UI/ProgressBar";
import { MonthPicker } from "../MonthPicker";
import { Popupmenu } from "../UI/PopupMenu";
import moment from "moment";
import { DOWNLOAD_OPTIONS } from "../../utils/constants";
import { useEmployeeDashBoard } from "./hooks/useEmployeeDashBoard";
import { Loader } from "../Loader/Loader";
import { Alert } from "../UI/Alert";
const MAX_PROGRESS_WIDTH = 200;
const MIN_PROGRESS_WIDTH = 20;

const getProgressWidth = (value, maxValue) => {
  if (!value || !maxValue) return MIN_PROGRESS_WIDTH;
  const percentage = (value / maxValue) * 100;
  const width = (percentage / 100) * MAX_PROGRESS_WIDTH;
  return Math.max(MIN_PROGRESS_WIDTH, Math.min(width, MAX_PROGRESS_WIDTH));
};

const EmployeeDashBoard = () => {
  const {
    handleMonthChange,
    selectedMonth,
    curMonthInfo,
    isLoading,
    toastInfo,
    monthStatistics,
    handleEventSelection,
    events,
    handleToastClose,
    generateTimesheetReport
  } = useEmployeeDashBoard();
  
  const { totalHours = 0, reportedHours = 0, vacationHours = 0, approvedHours = 0 } = monthStatistics || {};
  const maxHours = totalHours || 1;

  return (
    <StyledDashBoardContainer className="tma_emp_dashboard_container">
      {toastInfo && ( <Alert {...toastInfo} onToastClose={handleToastClose} />
      )}
      <header className="tma_dashboard_header">
        <h1>{translate("pageTitles.dashboard")}</h1>
        <div className="tma_dashboard_actions">
          <Popupmenu
            label={translate("labels.moreOptions")}
            popupOptions={DOWNLOAD_OPTIONS}
            variantstyle="secondary"
            disabled={events.length === 0}
            onOptionSelect={({key})=>{
              generateTimesheetReport(key);
            }}
          />
          <MonthPicker onMonthChange={handleMonthChange} />
        </div>
      </header>
     { monthStatistics && <section className="tma_employee_dashboard_summary">
        <div className="tma-text_summary">
          <div className="tma_billable_hrs_count tma_col">
            <span>{translate("labels.totalPossibleHours")}</span>
            <strong>{totalHours}h</strong>
            <ProgressBar
              value={totalHours}
              containerWidth={getProgressWidth(totalHours, maxHours)}
              progressColor={"#1976d2"}
            />
          </div>
          <div className="tma_vacation_hrs_count tma_col">
            <span>{translate("labels.approvedHours")}</span>
            <strong>{approvedHours}h</strong>
            <ProgressBar
              value={approvedHours}
              containerWidth={getProgressWidth(approvedHours, maxHours)}
              progressColor={"rgb(0, 255, 0)"}
            />
          </div>
          <div className="tma_reported_hrs_count tma_col">
            <span className="tma_opac">{translate("labels.reportedTime")}</span>
            <strong>{reportedHours}h</strong>
            <ProgressBar
              value={reportedHours}
              containerWidth={getProgressWidth(reportedHours, maxHours)}
              progressColor={"orange"}
            />
          </div>
          <div className="tma_vacation_hrs_count tma_col">
            <span>{translate("labels.holidayVacation")}</span>
            <strong>{vacationHours}h</strong>
            <ProgressBar
              value={vacationHours}
              containerWidth={getProgressWidth(vacationHours, maxHours)}
              progressColor={"rgb(197, 197, 197)"}
            />
          </div>
        </div>
        <div className="tma_progress_summary"></div>
      </section>}
      <section className="tma_employee_dashboard_content">
        <MonthEvents
          startDate={
            selectedMonth
              ? moment(selectedMonth.firstDay).format("YYYY-MM-DD")
              : moment(curMonthInfo.firstDay).format("YYYY-MM-DD")
          }
          eventsData={events}
          onEventSelected={handleEventSelection}
        />
      </section>
      {isLoading && <Loader />}
    </StyledDashBoardContainer>
  );
};

export default EmployeeDashBoard;
